
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[slugOrProductId]",
      function () {
        return require("private-next-pages/product/[slugOrProductId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[slugOrProductId]"])
      });
    }
  